import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PhoenixLogo } from '../components/PhoenixLogo';
import { requestPasswordReset } from '../utils/api';
import { C } from '../utils/constants';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await requestPasswordReset(email);
      // The backend always returns the same generic success regardless of
      // whether the email matched a user — to prevent account enumeration.
      // Show the same neutral confirmation either way.
      setSubmitted(true);
    } catch (err) {
      // Only request-validation errors (e.g. missing email) should hit here.
      // Server failures are also intentionally generic on the backend.
      const msg = err?.response?.data?.error || 'Something went wrong. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Dark hero section — matches Login.jsx */}
      <div style={{
        background: `linear-gradient(180deg, #1a0800 0%, #3d1f02 60%, ${C.cream} 100%)`,
        padding: '60px 24px 80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 16,
      }}>
        <PhoenixLogo size={220} />

        <h1 style={{
          fontFamily: "'Forum', serif",
          color: '#fff',
          fontSize: 'clamp(1.4rem, 5vw, 2.2rem)',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          marginTop: 8,
        }}>
          Recondition Yourself
        </h1>

        <p style={{
          fontFamily: "'Forum', serif",
          color: C.gold,
          fontSize: '1.1rem',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          fontWeight: 700,
        }}>
          Client Portal
        </p>
      </div>

      {/* Card */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 16px 48px',
        marginTop: -40,
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 16,
          padding: '36px 32px',
          width: '100%',
          maxWidth: 420,
          boxShadow: '0 8px 40px rgba(61,31,2,0.15)',
        }}>
          <h2 style={{
            fontFamily: "'Forum', serif",
            color: C.brown,
            fontSize: '1.6rem',
            letterSpacing: '0.03em',
            marginBottom: 6,
          }}>
            Forgot Password
          </h2>
          <p style={{
            color: C.terracotta,
            fontSize: '0.88rem',
            marginBottom: 28,
          }}>
            Enter your email and we'll send you a reset link.
          </p>

          {submitted ? (
            <>
              <div style={{
                background: 'rgba(107,62,10,0.08)',
                border: `1px solid ${C.border}`,
                borderRadius: 8,
                padding: '14px 16px',
                marginBottom: 20,
                color: C.brown,
                fontSize: '0.9rem',
                lineHeight: 1.5,
              }}>
                If an account exists for that email, a reset link is on its way. Check your inbox (and your spam folder, just in case).
              </div>
              <p style={{ fontSize: '0.85rem', color: C.terracotta, textAlign: 'center', marginTop: 8 }}>
                <Link to="/login" style={{ color: C.terracotta, textDecoration: 'underline' }}>
                  Back to sign in
                </Link>
              </p>
            </>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div style={{
                  background: 'rgba(173,121,91,0.12)',
                  border: `1px solid ${C.terracotta}`,
                  borderRadius: 8,
                  padding: '10px 14px',
                  marginBottom: 20,
                  color: C.terracotta,
                  fontSize: '0.85rem',
                  lineHeight: 1.4,
                }}>
                  {error}
                </div>
              )}

              <div style={{ marginBottom: 18 }}>
                <label style={{
                  display: 'block',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  color: C.brown,
                  marginBottom: 6,
                  letterSpacing: '0.04em',
                }}>
                  Email Address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoComplete="email"
                />
              </div>

              <button
                type="submit"
                className="btn-primary"
                disabled={loading}
                style={{ width: '100%', fontSize: '1rem', marginTop: 8 }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>

              <p style={{ fontSize: '0.85rem', color: C.terracotta, textAlign: 'center', marginTop: 18 }}>
                <Link to="/login" style={{ color: C.terracotta, textDecoration: 'underline' }}>
                  Back to sign in
                </Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
